import BackupTableIcon from '@mui/icons-material/BackupTable';
import CodeIcon from '@mui/icons-material/Code';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import TerminalIcon from '@mui/icons-material/Terminal';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { memo, useCallback, useState } from 'react';

function DevAppBar() {
  const [dev, setDev] = useState(false);

  const handleClose = useCallback(() => {
    setDev(false);
  }, []);

  return (
    <>
      <IconButton onClick={() => setDev(true)}><TerminalIcon /></IconButton>
      <Drawer anchor="right" open={dev} onClose={() => setDev(false)} PaperProps={{ sx: { width: "20vw" } }}>
        <MenuList>
          <MenuItem component="a" href="/_dev/dump_sql.php" target="_blank" onClick={handleClose}>
            <ListItemIcon>
              <BackupTableIcon />
            </ListItemIcon>
            <ListItemText>Database</ListItemText>
          </MenuItem>
          <MenuItem component="a" href="/_dev/dump_uploads.php" target="_blank" onClick={handleClose}>
            <ListItemIcon>
              <PermMediaIcon />
            </ListItemIcon>
            <ListItemText>Uploads</ListItemText>
          </MenuItem>
          <MenuItem component="a" href="/_dev/dump_program.php" target="_blank" onClick={handleClose}>
            <ListItemIcon>
              <CodeIcon />
            </ListItemIcon>
            <ListItemText>Programs</ListItemText>
          </MenuItem>
        </MenuList>
      </Drawer>
    </>
  )
}

export default memo(DevAppBar);
